const style = () => ({
  thumbnail: {
    width: 60,
    height: 60,
    backgroundSize: 'cover',
    cursor: 'pointer',
  },
  selectFileButton: {
    padding: 1,
  },
})

export default style
